<div class="one-week-free-agency">
  <div class="plans-container">
    <div class="plans-wrap"
         [class.two-column]="subscriptions.length === 2"
         [class.one-column]="subscriptions.length === 1"
         [class.responsive-stacked]="shouldStackPlans">
      <ng-container *ngFor="let plan of subscriptions">
        <div class="plan-item {{plan.tabCategory}} {{plan.category}}" [style.height]="!!couponPercent && '738px'">
          @if (planFeatures[plan?.category].mostPopular) {
            <div class="db-badge">BEST VALUE</div>
          }
          <div class="plan-item-header">
            <h3>{{ plan?.category === 'enterprise' ? 'Dedicated hosting' : plan.plan.title }}</h3>

            @if (plan?.category === 'enterprise') {
              <div class="db-custom">Custom</div>
            } @else {
              <div class="plan-item-price">
                ${{ (plan.plan.planPrice * (100 - (plan?.type === UserSubscriptionCategory.DedicatedVM ? 0 : couponPercent)) / 100) / plan.plan.periodNumber | DbNumberFormatPipe:  'ceil' }}
                <span>/mo</span></div>
            }
            <div class="plan-item-billed-period" [class.visibility-hidden]="plan?.category === 'enterprise' "
                 [style.height]="!!couponPercent && '42px'">
              @if (showSwitchAnnual && periodSwitch === 12 && isCurrentPlan(plan)) {
                <span>Billed ${{annualPrice}} annually</span>
              } @else {
                <span class="mb24">Billed {{ plan.plan.periodNumber === 12 ? 'annually' : 'monthly' }}</span>
              }
              </div>
            @if (isCurrentPlan(plan)) {
              @if (currentSubscription?.plan?.price === currentSubscription?.plan?.planPrice &&
              currentSubscription?.periodNumber < 6 &&
              periodSwitch === 12 &&
              !currentSubscription?.plan?.hasAddons &&
              !currentSubscription?.isExpired &&
              plan?.category !== 'enterprise' &&
              ![userSubscriptionStatus?.canceled, userSubscriptionStatus?.failed, userSubscriptionStatus?.expired].includes(currentSubscription?.status)) {
                <button class="ds-btn-max ds-btn-black" (click)="switchToAnnual()">
                  <span>Switch to Annual</span>
                </button>
              } @else {
                <button class="ds-btn-max ds-btn-gray ds-btn-disabled">
                  <span>Current plan</span>
                </button>
              }
            } @else {

              @if (plan?.category === 'enterprise') {
                <button class="ds-btn-max ds-btn-purple-blue" (click)="showTalkToSalesDialog()">
                  <span>Talk to sales</span>
                </button>
              } @else {
                <button class="ds-btn-max ds-btn-black"
                        (click)="chooseSubscription(plan)">
                <span>{{canSwitch && !invitedUser ? 'Switch plan' : 'Upgrade now'}}</span>
                </button>
              }
            }
          </div>
          <div class="db-one-week-free-demo__plan-info">
            <!-- Main Features -->
            <div class="feature-list mb24">
              <div *ngFor="let feature of getPlanFeatures('mainFeatures', plan)"
                   class="feature-item" [class.has-video]="feature?.hasVideo" [dsTooltipSize]="'small'"
                   [dsTooltipMode]="'hoverStatic'" [dsTooltipVisible]="feature?.hasVideo"
                   [dsTooltip]="copilot"
                   [dsTooltipWithVideo]="true"
                   [dsTooltipPosition]="'bottom'"
                   [dsTooltipAlign]="'left'"
                   [hostClass]="'cover-all'">
                <div>
            <span class="feature-icon">
              <i class="db-icon db-icon-ds-checkmark-sharp"></i>
            </span>
                  <span class="feature-text" [innerHTML]="feature?.text">
            </span>
                  <span class="feature-video" *ngIf="feature?.hasVideo"><i
                    class="db-icon db-icon-ds-play-small"></i></span>
                </div>
                <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
            monthlyVisitors: (plan?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
            ssdStorage: (plan?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
            aiWebsites: plan?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
            cdnBandwidth: (plan?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
            websites: plan?.plan?.services?.hosting?.domain_count?.parameter_value,
            period: periodSwitch === 12 ? '1 year' : '1 month'
          })"></span>
              </div>
            </div>

            <!-- Everything in Previous Plan -->
            <ng-container *ngIf="getPlanFeatures('everythingInPrevious', plan)">
              <div class="feature-section mt24">
                <h3>Everything in {{ getPlanFeatures('everythingInPrevious', plan).previousPlan }} Plus</h3>
                <div class="feature-list">
                  <div *ngFor="let feature of getPlanFeatures('everythingInPrevious', plan).features"
                       class="feature-item">
                    <div>
                <span class="feature-icon">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                </span>
                      <span class="feature-text" [innerHTML]="feature?.text">
                </span>
                    </div>
                    <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (plan?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (plan?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: plan?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (plan?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: plan?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitch === 12 ? '1 year' : '1 month'
              })"></span>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Secondary Features -->
            <ng-container *ngIf="getPlanFeatures('secondaryFeatures', plan)">
              <div class="feature-section mt24">
                <div class="feature-list">
                  <div *ngFor="let feature of getPlanFeatures('secondaryFeatures', plan)" class="feature-item">
                    <div>
                      @if (!feature.hideIcon) {
                        <span class="feature-icon">
                         <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                         </span>
                      }
                      <span class="feature-text" [innerHTML]="feature?.text"></span>
                    </div>
                    <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (plan?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (plan?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: plan?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (plan?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: plan?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitch === 12 ? '1 year' : '1 month'
              })"></span>
                    <div *ngIf="feature.hasImages" class="db-image">
                      <img src="assets/images/logos/payment-methods.svg"/>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Platform Features -->
            <ng-container *ngIf="getPlanFeatures('platformFeatures', plan)">
              <div class="feature-section__secondary mt24">
                <h3>Platform Features</h3>
                <div class="feature-list">
                  <div *ngFor="let feature of getPlanFeatures('platformFeatures', plan)" class="feature-item">
                    <div>
                <span class="feature-icon">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                </span>
                      <span class="feature-text" [innerHTML]="feature?.text">
                </span>
                    </div>
                    <span *ngIf="feature.value" class="feature-value" [innerHTML]="replaceParam(feature.value, {
                monthlyVisitors: (plan?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                ssdStorage: (plan?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                aiWebsites: plan?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                cdnBandwidth: (plan?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                websites: plan?.plan?.services?.hosting?.domain_count?.parameter_value,
                period: periodSwitch === 12 ? '1 year' : '1 month'
              })"></span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="features-container">
    <h2>All plans include</h2>
    <div class="features-grid">
      <ng-container *ngFor="let column of allPlansFeatures">
        <div class="features-category-column">
          <ng-container *ngFor="let category of column">
            <div class="features-category">
              <h3>{{ category.title }}</h3>
              <ul>
                <li *ngFor="let item of category.items">
                  <i class="db-icon db-icon-ds-checkmark-sharp"></i>
                  <span
                    class="features-category-item-text"
                    [innerHTML]="item"
                  ></span>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #copilot>
  <div class="video-tooltip">
    <p>EXPLORE AI COPILOT FEATURES</p>
    <!-- Image Instead of Video -->
    <div class="video-thumbnail" (click)="openVideoPopup()">
      <img src="assets/images/upgrade-plan/copilot_iframe.jpg"
           alt="Explore AI Copilot Features"/>
      <i class="db-icon db-icon-ds-media-play"></i>
    </div>
  </div>

</ng-template>
